function preload() {
  /* ACCORDION MOBILE MENU */
  function drive_accordion_mobile() {
    let accordMainToggle = document.querySelector('.toggle'),
      block = document?.querySelector('.toggle-block'),
      menu = document?.querySelector('.top_head_mobile_menu >li:has(ul)'),
      allMenu = document?.querySelectorAll('.top_head_mobile_menu'),
      subMenu = document.querySelectorAll('.sub-menu'),
      html = document?.querySelector('html');

    accordMainToggle.addEventListener('click', () => {
      accordMainToggle?.classList.toggle('toggleActive');
      block?.classList.toggle('active');

      block.classList.contains('active')
        ? (html.style.overflowY = 'hidden')
        : (html.style.overflowY = 'scroll');
    });

    menu?.insertAdjacentHTML(
      'afterbegin',
      '<i class="fa fa-angle-down sub-arrow"></i>'
    );

    let accordToggle = document.querySelector('.sub-arrow');

    accordToggle?.addEventListener('click', () => {
      [...subMenu][1].classList.toggle('active');
      menu.querySelector('a').classList.toggle('link-active');
      menu.firstChild.classList.toggle('arrow-active');
    });

    allMenu.forEach((menu) => {
      const links = menu.querySelectorAll('a');
      links.forEach((link) => {
        link.onclick = function () {
          block.classList.remove('active');
          accordMainToggle.classList.remove('toggleActive');
          html.style.overflowY = 'scroll';
        };
      });
    });
  }

  /* Блокировка кнопки отправки формы */
  function setFormCheckbox(arr, btn) {
    arr = Array.from(arr);
    btn = Array.from(btn);

    btn.map((it) => it.setAttribute('style', 'display:none'));

    try {
      arr.forEach((item, idx) => {
        item.addEventListener('change', function () {
          if (!arr.find(() => !arr[idx].checked)) {
            btn[idx].removeAttribute('style');
          } else {
            btn[idx].setAttribute('style', 'display:none');
          }
        });
      });
    } catch (e) {}
  }

  /* Баннер Куки */
  function setBannerCookie() {
    const banner = document?.querySelector('.cookieBanner');

    setTimeout(() => {
      banner?.classList.add('cookieBanner-active');
      if (document.cookie.indexOf('warning') != -1) {
        banner.classList.remove('cookieBanner-active');
      }
    }, 100);

    if (banner) {
      const button = banner.querySelector('.cookieBanner__btn');
      button.addEventListener('click', () => {
        banner?.classList.remove('cookieBanner-active');
        document.cookie = 'warning=true; max-age=2592000; path=/';
      });
    }
  }

  setBannerCookie();
  drive_accordion_mobile();
  setFormCheckbox(
    document.querySelectorAll('.custom-checkbox'),
    document.querySelectorAll('.wpcf7-submit')
  );
}

document.addEventListener('DOMContentLoaded', () => {
  preload();
});
